import clsx from 'clsx'
import styles from './styles.module.scss'
import { IAvatarProps } from './types'
import { useImgLoadingState } from './useImgLoadingState'

const Avatar = ({ alt, className, size = 'md', src, style, ...props }: IAvatarProps) => {
  const { isLoaded } = useImgLoadingState(src)

  return (
    <div
      className={clsx('mui-avatar', styles.wrapper, styles[size], className)}
      data-testid="mui-avatar"
      style={style}
      role={isLoaded ? 'img' : 'presentation'}
      aria-hidden={!isLoaded}
    >
      {isLoaded ? (
        <img alt={alt} className={clsx(styles.image)} src={src} {...props} />
      ) : (
        <span className={clsx(styles.alt)} role="presentation" aria-hidden="true">
          {alt.slice(0, 3)}
        </span>
      )}
    </div>
  )
}

export default Avatar
